export default __webpack_public_path__ + "static/media/logo.891e3406.svg";